import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { isWhiteLabelHost } from "@/utils/appUrl";

/**
 * Garante que hosts white-label (amecardapio.com, subdomínios de fornecedor e
 * domínios próprios como cardapio.theporkys.com.br) nunca sejam indexados,
 * evitando concorrência entre a marca do fornecedor e a marca AmeUp.
 *
 * A limpeza de ícones/títulos da AmeUp é feita pelo WhiteLabelBrandingProvider.
 */
export const WhiteLabelNoIndex = (): JSX.Element | null => {
  const whiteLabel = typeof window !== "undefined" && isWhiteLabelHost();

  useEffect(() => {
    if (!whiteLabel) return;

    // Silencia ruídos de telemetria de terceiros no domínio do fornecedor.
    const originalWarn = console.warn;
    console.warn = (...args) => {
      if (
        args[0] &&
        typeof args[0] === "string" &&
        (args[0].includes("Meta Pixel") || args[0].includes("analytics"))
      ) {
        return;
      }
      originalWarn.apply(console, args);
    };

    return () => {
      console.warn = originalWarn;
    };
  }, [whiteLabel]);

  if (!whiteLabel) return null;

  return (
    <Helmet prioritizeSeoTags>
      <meta name="robots" content="noindex, nofollow" />
      <meta name="googlebot" content="noindex, nofollow" />
    </Helmet>
  );
};

export default WhiteLabelNoIndex;
